/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAuthorFeed.defs.js'
export { main as default } from './getAuthorFeed.defs.js'
